import { Container } from "@brightagency/headstart-common";
import React from "react";
import { WPImage } from "../../../constants/types/index";
import { LocationLanguageButtons } from "../../molecules/LocationLanguageButtons";
import { Outer, Inner, Title, PreTitle, ImageWrapper, ContentWrapper, SubTitle } from "./styled";

interface Props {
    regionName: any;
    suburbName?: string;
    bannerImage: WPImage;
    mobileBannerImage: WPImage;
}

export const HeroHome: React.FC<Props> = props => {
    const { suburbName, bannerImage, regionName, mobileBannerImage } = props;
    return (
        <Outer>
            <Container>
                <ContentWrapper>
                    <Inner>
                        <Title>
                            {suburbName ? (
                                <>
                                    <strong>Find mental health support for <span>{suburbName}</span></strong>
                                </>
                            ) : (
                                <>
                                    <strong className="larger-font">Find mental health <span>support</span></strong>
                                </>
                            )}
                        </Title>
                        {!suburbName ? (
                            <SubTitle>for you or someone you care for</SubTitle>
                        ) : null }
                        <PreTitle>
                            {suburbName ? (
                                <>
                                    {suburbName} is in the {regionName} health region
                                </>
                            ) : (
                                <>
                                    Including free and low-cost services available in-person and online
                                </>
                            )}
                        </PreTitle>
                        <LocationLanguageButtons showLanguages hideLanguagesDesktop suburbCondition={true} />
                    </Inner>
                    <ImageWrapper
                        suburbSelected={!!suburbName}
                    >
                        <img className={"medium-lower-hidden"} src={bannerImage?.url} alt="Hero Banner" />
                        <div className="medium-lower-visible">
                            <img src={mobileBannerImage?.url} alt="Hero Banner" />
                            <div className="image-background" />
                        </div>
                    </ImageWrapper>
                </ContentWrapper>
            </Container>
        </Outer>
    );
};
